module.exports = __webpack_public_path__ + "img/Service-ability-02.ebe8b8f7.png";